import React from 'react';
import { useParams } from 'react-router-dom';

import IntegrationSlice from 'pages/Hardware/Integrations/SelectIntegration';
import IntegrationsHeader from 'pages/Hardware/Integrations/IntegrationsHeader';

import forms from './Forms';

function Payment() {
  const { level } = useParams();
  return (
    <div>
      <IntegrationsHeader
        goToPath="/hardware/integrations"
        level={level}
        title="Payment"
      />
      <IntegrationSlice integrationType="payment" />
    </div>
  );
}

export default {
  linkName: 'Payment',
  hidden: true,
  exact: true,
  path: '/hardware/integrations/:level/:level_id/payment',
  component: Payment,
  subRoutes: [forms],
  rootPath: { name: 'Hardware', uri: '/hardware' },
  subPath: [
    { name: 'Integrations', uri: '/hardware/integrations' },
    { name: 'Payment' },
  ],
};
